export default "__VITE_ASSET__bba375e2__"